import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { cn } from '@/lib/cn';

interface Props {
  text: string;
  label?: string;
  className?: string;
}

/** Extracted from the copy-to-clipboard pattern already used in DeviceDetailDrawer.tsx (icon + a 2s "copied" flash), generalized so callers don't repeat the same useState/setTimeout wiring. */
export function CopyButton({ text, label = 'Copy', className }: Props) {
  const [copied, setCopied] = useState(false);

  const copy = () =>
    navigator.clipboard?.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });

  return (
    <button
      type="button"
      onClick={copy}
      className={cn(
        'inline-flex items-center gap-1 rounded-md border border-slate-200 px-2 py-1 text-xs font-medium text-slate-600 transition hover:bg-slate-50',
        className,
      )}
    >
      {copied ? (
        <>
          <Check className="h-3.5 w-3.5 text-green-600" /> Copied
        </>
      ) : (
        <>
          <Copy className="h-3.5 w-3.5" /> {label}
        </>
      )}
    </button>
  );
}
